import type {KeyTextField, NumberField, SelectField} from '@prismicio/client'
import cn from 'classnames'
import {StarRating} from 'src/common/StarRating'

type StarRatingsProps = {
  review: {
    review_platform?: string
    label: KeyTextField
    rating: NumberField
    color?: SelectField<'Neon/550' | 'Grey' | 'Neon/300'>
  }
  color?: 'Neon/550' | 'Grey'
  darkBackground?: boolean
}

export const StarRatings = ({review, darkBackground = false}: StarRatingsProps) => {
  const color = darkBackground ? 'Neon/300' : review.color || 'Grey'

  return (
    <div className="flex justify-center gap-[6px] text-14 leading-5 tracking-[.28px]">
      <p
        className={cn({
          'text-moss-white': darkBackground,
          'text-grey-550': !darkBackground,
        })}
      >
        {review.label || review.review_platform}
      </p>
      <StarRating rating={review.rating || 5} {...(darkBackground && {color: 'Neon/300'})} color={color} />
      <p
        className={cn({
          'text-moss-white': darkBackground,
          'text-grey-550': !darkBackground,
        })}
      >
        {review.rating}
      </p>
    </div>
  )
}
